import {ReactNode} from 'react';
import {Box} from '@mui/material';

type Props = {
  children: ReactNode;
};

export const FilterRow = ({children}: Props) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1.5}
      flexWrap="wrap"
      sx={{minWidth: 0}}
    >
      {children}
    </Box>
  );
};
